import axios from "axios";

export default async function crmEnquiry(body) {
  const payload = {
    process: "KAM",
    mobileNumber:
      body.location === "Bengaluru" || body.location === "Bangalore"
        ? "website_bnglre"
        : body.location === "Mysore"
        ? "website_mys"
        : body.location === "Hyderabad" || body.location === "Hydrabad"
        ? "website_hyd"
        : "",
  };

  try {
    // First API call
    const getSkill = await axios.post(
      "https://demo.zuqodemo.world:4342/admin/getRoutingSkillForUpload/",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Axi12#$ eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoiNjY2MTJiYWU4MjkwZjZiNWI2ZjAwOTk5IiwiaWF0IjoxNzQyMTg0Mjc2LCJleHAiOjE3NzM3MjAyNzZ9.Z-rMS2RklsawdXAZNHYQ3x6BiRB_AdkCeMbRyWIZPm0",
        },
      }
    );
    const getSkillData = getSkill.data.data.selectedDid;
    const leadPayload = [
      {
        ...body,
        agentId: getSkillData.agentId,
        creAgent: getSkillData.agentId,
        skill: getSkillData.skill,
      },
    ];
    const createLead = await axios.post(
      "https://demo.zuqodemo.world:4342/admin/campaign/uploadLeadsToWeb",
      leadPayload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization:
            "Axi12#$ eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjoiNjY2MTJiYWU4MjkwZjZiNWI2ZjAwOTk5IiwiaWF0IjoxNzQyMTg0Mjc2LCJleHAiOjE3NzM3MjAyNzZ9.Z-rMS2RklsawdXAZNHYQ3x6BiRB_AdkCeMbRyWIZPm0",
        },
      }
    );
    return createLead;
  } catch (error) {
    console.error("Error in crmEnquiry:", error);
    throw error;
  }
}
